import { atom, selector } from 'recoil';
import { verificarToken } from './storage';

const loginEffect =
  () =>
  ({ trigger, onSet, setSelf }) => {
    const token = localStorage.getItem('tokenEcosurEstudiantesExternos');
    if (trigger === 'get' && token && verificarToken(token)) {
      setSelf(true);
    }
    onSet((newValue: Boolean) => {
      if (newValue) {
        token && verificarToken(token) ? setSelf(true) : setSelf(false);
      } else {
        setSelf(false);
      }
    });
  };

const loginRolEffect =
  () =>
  ({ trigger, onSet, setSelf }) => {
    const key = 'rolEcosurEstudiantesExternos';
    const rol = localStorage.getItem(key);
    if (trigger === 'get' && rol) {
      setSelf(rol);
    }
    onSet((newValue: any) => {
      localStorage.setItem(key, newValue);
      setSelf(newValue);
    });
  };

export const loginState = atom({
  key: 'loginState',
  default: false,
  effects: [loginEffect()],
});

export const loginRol = atom({
  key: 'loginRol',
  default: '',
  effects: [loginRolEffect()],
});

export const loginInfo = selector({
  key: 'loginInfo',
  get: ({ get }) => ({
    login: get(loginState),
  }),
});

export const loginRolInfo = selector({
  key: 'loginRolInfo',
  get: ({ get }) => ({
    rol: get(loginRol),
  }),
});
